export default __webpack_public_path__ + "static/media/whiteBg.28e45db0.png";